import http from '../utils/http';
import cookie from '../utils/cookies';
import queryString from '../utils/query-string';
import User from '../view-model/users/User';
import UserSign from '../view-model/users/UserSign';
import UserLogin from '../view-model/users/UserLogin';
import UserResetPassword from '../view-model/users/UserResetPassword';
import UserForgotPassword from '../view-model/users/UserForgotPassword';

type SubscriptionCallback = ((newData?: Partial<User>) => void) | ((newData?: Partial<User>) => Promise<void>);

const subscriptions: (SubscriptionCallback | null)[] = [];

const subscribe = (callback: SubscriptionCallback) => {
    subscriptions.push(callback);

    return () => unsubscribe(subscriptions.length - 1);
};

const unsubscribe = (index: number) => {
    subscriptions[index] = null;
};

const updateUserInfo = async (newData?: Partial<User>) => {
    for (const subscription of subscriptions)
        if (subscription)
            try {
                await subscription(newData);
            } catch (error) {}
};

const getQueryStringToken = () =>
    queryString.get('token');

const getTrack = () =>
    cookie.get('track');

const getActiveUserToken = () => {
    let match = document.cookie.match('\\btoken-auth=([^;]*)\\b');

    return match && match[1] ? match[1] : null;
};

const getActiveUser = () => {
    const token = getActiveUserToken();

    if (!token)
        return null;

    return http.get<User>('/v2.1/auth/profile', { auth: token });
};

const login = async (credentials: UserLogin) => {
    const response = await http.post<string>('/v2.1/auth/login', null, {
        auth: [credentials.login, credentials.password],
        credentials: 'include'
    });

    await updateUserInfo();

    return response;
};

const logout = async () => {
    const response = await http.post<null>('/v2.1/auth/logout', null, {        
        credentials: 'include'
    });

    await updateUserInfo();

    return response;
};

const sign = (user: UserSign) =>
    http.post<null>('/v2.1/auth/register', user, { auth: false, credentials: 'include' });

const resetPassword = (passwordReset: UserResetPassword) =>
    http.post<null>(`/v2.1/auth/reset-password?token=${getQueryStringToken()}`, passwordReset, { auth: false });

const activateAccount = (token: string) =>
    http.post<null>(`/v2.1/auth/verify-email?token=${token}`, { auth: false });

const forgotPassword = (forgotPasswordData: UserForgotPassword) =>
    http.post<null>('/v2.1/auth/forgot-password', forgotPasswordData, { auth: false });

const authService = { subscribe, updateUserInfo, getActiveUser, logout, login, sign, getActiveUserToken, getQueryStringToken, getTrack, resetPassword, activateAccount, forgotPassword };

export default authService;
